<template>
  <div class="trend-insight" v-loading.fullscreen.lock="loading">
    <div class="new-btn">
      <el-button icon="el-icon-plus" size="small" type="warning" @click="dialogUploadVisible = true">Upload</el-button>
    </div>
    <el-dialog :visible.sync="dialogUploadVisible" @close="closeUploadDialog" title="Import Weekly Trend Insight"
      width="40%">
      <el-form style="margin-top: 10px;" ref="form" :model="form" size="mini" label-width="90px">
        <el-form-item label="Date" prop="date" required>
          <el-input size="small" placeholder="20250101" v-model="form.date" />
        </el-form-item>
        <el-form-item label="Lang" prop="lang" required>
          <el-radio-group v-model="form.lang">
            <el-radio label="en">EN</el-radio>
            <el-radio label="zh">CN</el-radio>
            <el-radio label="ko">KR</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="form-item-upload" style="line-height: 32px;" label="HTML File" required>
          <el-upload class="upload-btn"
            :action="aiApiRoot + '/v1/admins/trend-insights/import/' + form.date + '/' + form.lang" accept=".html"
            :headers="{ Authorization: this.token }" ref="upload" :auto-upload="false" :on-error="onError"
            :on-change="onChange" :on-success="onSuccess" :before-remove="beforeRemove" :limit="1">
            <el-button size="small" slot="trigger" icon="el-icon-upload2">Click to Upload</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" :disabled="!enableSubmit" size="small" @click="onSubmit">OK</el-button>
      </span>
    </el-dialog>
    <el-table :data="tableData" row-key="id">
      <el-table-column prop="date" label="Date"></el-table-column>
      <el-table-column label="Lang">
        <template slot-scope="scope">
          {{ scope.row.lang | langFilter() }}
        </template>
      </el-table-column>
      <el-table-column label="Create At" min-width="110">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{
            scope.row.createdAt | displayTime()
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Delete" min-width="50" align="center">
        <template slot-scope="scope">
          <el-popconfirm title="Delete Trend Insight?" @confirm="deleteTrendInsight(scope.row.id)">
            <el-button type="danger" icon="el-icon-delete" circle size="small" slot="reference"></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" :total="total" :offset.sync="listQuery.offset" :limit.sync="listQuery.limit"
      layout="sizes, prev, pager, next, total " @pagination="fetchData" />
  </div>
</template>

<script>
import { fetchTrendInsight, deleteTrendInsight } from "@/api/admin";
import Pagination from "@/components/Pagination";
import { aiApiRoot } from "@/utils/server";
import { getToken } from "@/utils/auth";

export default {
  components: { Pagination },
  data() {
    return {
      token: "Bearer " + getToken(),
      aiApiRoot,
      dialogUploadVisible: false,
      form: {
        date: "",
        lang: "en",
      },
      tableData: [],
      listQuery: {
        date: "",
        offset: 0,
        limit: 10,
      },
      total: 0,
      loading: false,
      enableSubmit: false,
    };
  },
  mounted() {
    this.active();
  },
  methods: {
    active() {
      this.fetchData();
    },
    fetchData() {
      fetchTrendInsight(this.listQuery).then(response => {
        if (response.success) {
          this.tableData = response.result.items || [];
          this.total = response.result.totalCount;
        }
      })
    },
    deleteTrendInsight(id) {
      deleteTrendInsight(id).then((response) => {
        if (response.success) {
          this.$notify({
            title: "Delete successful",
            type: "success",
          });
          this.fetchData();
        }
      });
    },
    onSubmit() {
      this.enableSubmit = false;
      this.loading = true;
      this.$refs.upload.submit();
    },
    onChange(file, fileList) {
      if (fileList && fileList.length > 0) {
        this.enableSubmit = true;
      } else {
        this.enableSubmit = false;
      }
    },
    beforeRemove() {
      this.enableSubmit = false;
      return true;
    },
    onSuccess(response) {
      this.$refs.upload.clearFiles();
      if (!response.success) {
        this.$message({
          showClose: false,
          message: response && response.error ? response.error.message : "",
          type: "error",
        });
      }
      this.loading = false;
      this.closeUploadDialog();
      this.fetchData();
    },
    onError(err) {
      this.loading = false;
      this.$refs.upload.clearFiles();
      if (err && err.message) {
        let res = JSON.parse(err.message);
        if (res && res.error && res.error.message) {
          this.$message({
            showClose: false,
            message: res.error.message,
            type: "error",
          });
          return;
        }
      }
      this.$message({
        showClose: false,
        message: err,
        type: "error",
      });
    },
    closeUploadDialog() {
      this.dialogUploadVisible = false;
      this.form = {
        date: "",
        lang: "en",
      };
    },
  },
  filters: {
    langFilter(lang) {
      const langMap = {
        zh: "CN",
        en: "EN",
        ko: "KR",
      };
      return langMap[lang];
    },
  },
};
</script>

<style lang="scss" scoped>
.trend-insight {

  .new-btn {
    width: 100%;
    margin-bottom: 10px;
  }

  .form-item-upload ::v-deep .el-form-item__label {
    line-height: 34px;
  }
}
</style>